import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import Loader from './Loader';

export default function Logout() {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  useEffect(() => {
    window.localStorage.removeItem('auth');
    auth.setAuth(null);
    navigate('/');
  }, []);

  return <Loader />
}
